// list order determines order in the chooser UI

const payment_input = {
    field_type: 'input',
    key: 'url',
    element: {
        label: 'Enter a link to your payment page.',
        placeholder: 'paypal.me/username',
        note: 'Enter a link to paypal.me, cash.me, or other payment site.',
    },
}

const buttonset = {
    field_type: 'buttonset',
    buttons: [
        {
            type: 'submit',
            label: 'Save',
            loading_label: 'Saving…',
            className: 'button fullwidth dark primary xlarge',
        },
    ],
}

// glyph_chooser idea
// const glyph_chooser = {
//     field_type: 'glyph_chooser',
//     key: 'glyph',
//     glyphs: [
//         'person',
//         'credit-card',
//         'handshake',
//         'lightning',
//         'login',
//     ],
// }
// spotlight_form.html
// <: if (field.field_type === 'glyph_chooser') { :>
//     <fieldset class="glyph-chooser">
//         <label class="label">Choose an icon:</label>
//         <: field.glyphs.forEach(function(glyph) { :>
//             <button type="button" class="button xlarge glyph-center glyph-{{glyph}}">&nbsp;</button>
//         <: }) :>
//     </fieldset>
// <: } :>

const payment_list = [
    {
        id: 'pay_me',
        label: 'Pay me',
        glyph: 'person',
        default: true,
        fields: [payment_input, buttonset],
    },
    {
        id: 'send_payment',
        label: 'Send a payment',
        glyph: 'credit-card',
        fields: [payment_input, buttonset],
    },
    {
        id: 'make_contribution',
        label: 'Make a contribution',
        glyph: 'handshake',
        fields: [payment_input, buttonset],
    },
    {
        id: 'fund_project',
        label: 'Fund my project',
        glyph: 'lightning',
        fields: [payment_input, buttonset],
    },
    {
        id: 'send_money',
        label: 'Send me money',
        glyph: 'login',
        fields: [payment_input, buttonset],
    },
]

// assign link mechanism
// all spotlights in this list are not premium
payment_list.forEach(spotlight => {
    spotlight.is_premium = true
    spotlight.mechanism = 'payment_link'
    spotlight.group = 'payment'
})

module.exports = payment_list
